import config from '../../config';
import { request } from '../../libraries/request'

const getAll = (params = {}, token) => {
  console.log('SERVICES::CELLS::get', params, token);
  if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) { 
    params.order_by = 'created_at';
    params.order_direction = 'DESC';
  }

  return request({
    url: config.BASE_API_URL + config.API.CELLS,
    accessToken: token,
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

const save = (params, token) => {
  console.log('SERVICES::CELLS::save', params, token);
  return request({
    url: config.BASE_API_URL + config.API.CELLS,
    accessToken: token,
    method: 'POST',
    data: params
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const update = (params, token) => {
  console.log('SERVICES::CELLS::update', params, token);
  return request({
    url: config.BASE_API_URL + config.API.CELL.replace('{id}', params.id),
    accessToken: token,
    method: 'PATCH',
    data: params
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const get = (params, token) => {
  console.log('SERVICES::CELLS::get', params.id, token);
  return request({
    url: config.BASE_API_URL + config.API.CELL.replace('{id}', params.id),
    accessToken: token,
    // data: {},
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })

}

const del = (params, token) => {
  console.log('SERVICES::CELLS::remove', params.id, token);
  return request({
    url: config.BASE_API_URL + config.API.CELL.replace('{id}', params.id),
    accessToken: token,
    method: 'DELETE',
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

export default {
  getAll,
  save,
  get,
  del,
  update,
};